import { getData } from "../Editor/core/Utils";
import { loadChart } from "./Charts";
import { loadGraph } from "./Graphs";


export function loadPropItem(obj:HTMLElement){
    const data = getData(obj);

    switch(data.type){
        case "graph":
            loadGraph(obj, data);
        break;
        case "chart":
            loadChart(obj, data);
        break;
    }

}
